import {WinPresentationController} from "../WinPresentationController";
import {WalkOfShame} from "../../WalkOfShame";
import {TimelineLite} from "gsap";
import {WalkOfShameGameConfig} from "../../WalkOfShameGameConfig";

export class RowSplitController extends WinPresentationController {
    private _mainTimeline: TimelineLite | null;

    constructor() {
        super("RowSplitController", true);
    }

    protected hasWin(): boolean {
        return (WalkOfShame.model.parsedGameData.scatter2feature === "Row");
    }

    protected async createWinAnimation(): Promise<void> {
        const tl: TimelineLite = new TimelineLite(),
            splitId: number = WalkOfShame.model.parsedGameData.splitId,
            isWin: boolean = (WalkOfShame.model.parsedGameData.betWins.length > 0)

        tl.add(WalkOfShame.stickyS2.playXSplitAnimation(isWin), 0);

        for (let reel: number = 1; reel < WalkOfShameGameConfig.REELS_NUM; reel++) {
            tl.add(WalkOfShame.splitAnimation.playSplitAnimation(reel, splitId, 0), 0);
        }

        tl.add(() => {
            for (let reel: number = 1; reel < WalkOfShameGameConfig.REELS_NUM; reel++) {
                WalkOfShameGameConfig.SYMBOLS_COUNT_IN_REELS[reel]++;

                if (WalkOfShame.mToWild.ifFullSymExistsOnReel(reel)) {
                    WalkOfShame.mToWild.enableSymbolCount(reel);
                } else {
                    WalkOfShame.symbolCount.showItem(reel, splitId);
                }
            }

            WalkOfShame.possibleWays.updatePossibleWays(isWin);
        }, 0.66);

        if (!isWin) {
            tl.timeScale(3);
        }

        this._mainTimeline = tl;
        await tl;
        this._mainTimeline = null;
    }

    protected skip(): void {
        this._mainTimeline?.progress(1);
    }
}